import dClient, { clientNoLoader } from "../../Components/api/reduxLoaderApi";
import failStatus from "../../Components/utils/failStatus";
import {notification} from "../../Components/functions/notification/notificationFunction";
import React from "react";
import {initDiscountCodeForm, setDiscountCodes} from "./slice";
import {getProductsByIds} from "../product/thunks";



export const getDiscountCodeById = ({id}, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'get',
        `admin/coupons/${id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(initDiscountCodeForm(res.data.data))
    res.data.data.condition.Product && dispatch(getProductsByIds(res.data.data.condition.Product))
    return callback && callback( res.data.data.condition);
};


export const createDiscountCode = (data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/coupons`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ایجاد شد</h3>, false))
    return callback && callback();
};

export const editDiscountCode = (id, data, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'post',
        `admin/coupon/${id}`,
        data,
        {},
        1,
        true,
    );
    if (failStatus(res, dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت ویرایش شد</h3>, false))
    return callback && callback();
};

export const deleteDiscountCode = ({ discount_id }, callback = false) => async (
    dispatch,
    getState,
) => {
    const res = await dClient(
        'delete',
        `admin/coupons/${discount_id}`,
        {},
        {},
        1,
        true,
    );
    if (failStatus(res,dispatch)) return '';
    dispatch(notification("success", "", <h3>با موفقیت حذف شد</h3>, false))
    return callback && callback(res);
};